import { useCallback, useEffect, useRef, useState } from "react";
import moment from "moment";
import { useMqttProperty } from "./useMqttClient";

export function useDelayedOfflineStatus(componentId: string) {
  const [state, setState] = useState<{ status: string; dateTime: string; isLoading: boolean }>({
    status: "N/A",
    dateTime: "",
    isLoading: true,
  });

  const lastStatusRef = useRef<string>("N/A");
  const offlineTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const clearOfflineTimeout = useCallback(() => {
    if (offlineTimeoutRef.current) {
      clearTimeout(offlineTimeoutRef.current);
      offlineTimeoutRef.current = null;
    }
  }, []);

  useEffect(() => {
    return () => {
      clearOfflineTimeout();
    };
  }, [clearOfflineTimeout]);

  useMqttProperty(
    "status",
    componentId,
    undefined,
    (data: {
      status: string;
      metadata: {
        utc_timestamp: number;
      };
    }) => {
      const newStatus = data.status;
      const newDateTime =
        data.metadata.utc_timestamp != null
          ? moment.tz(data.metadata.utc_timestamp * 1000, "Europe/Ljubljana").format("DD.MM.yyyy HH:mm:ss")
          : "N/A";

      clearOfflineTimeout();
      if (lastStatusRef.current === "online" && newStatus === "offline") {
        offlineTimeoutRef.current = setTimeout(() => {
          setState({ status: newStatus, dateTime: newDateTime, isLoading: false });
          lastStatusRef.current = newStatus;
        }, 10_000);
      } else {
        setState({ status: newStatus, dateTime: newDateTime, isLoading: false });
        lastStatusRef.current = newStatus;
      }
    },
  );

  return state;
}
